import Cookies from 'js-cookie'
$(document).ready(function($) {
    const announcement = Cookies.get('announcement');

    if (announcement === undefined) {
        setTimeout(() => {
            $('#announcement').modal('show');
        }, 1500);
    }

    $('#announcement').on('hidden.bs.modal', function (e) {
        Cookies.set('announcement', 'showed', { expires: 4 });
    });
});
